import React from "react"

const Form = props => {
  return (
    <>
      {props.title && <h3>{props.title}</h3>}
      <iframe
        src={props.formLink}
        className={props.className}
        style={{ minHeight: props.height }}
        width="100%"
        id="pardot-form"
        title={props.title}
      ></iframe>
    </>
  )
}

export default Form
